<template>
  <div class="homeStyle">
    <Tabbar @toMore="toMore" :title="title" :enlishTitle="enlishTitle"></Tabbar>
    <Empty v-if="isEmpty"></Empty>
    <VideoList
      v-else
      :resultList="resultList"
      :loading="loading"
      :isEmpty="isEmpty"
      :homeShow="false"
    ></VideoList>
  </div>
</template>

<script>
import Tabbar from './Tabbar.vue'
import VideoList from '../../MTrainKnowledgeProduce/component/videoList.vue'
import { getVideoList } from '@/api/MTrainVideo'
import Empty from '@/components/common/Empty';

export default {
  data() {
    return {
      title: '知产培训',
      enlishTitle: 'PRODUCTION KNOWLEDGE TRAINING',
      loading: false,
      isEmpty: false,
      searchParams: {
        videoType: '',
      },
      pageParams: {
        pageSize: 8,
        pageNum: 1,
      },
      resultList: [],
    }
  },
  mounted() {
    this.loadData()
  },
  components: {
    Tabbar,
    VideoList,
    Empty
  },
  methods: {
    // 加载数据
    async loadData() {
      try {
        this.loading = true;
        const { rows, total } = await getVideoList(this.pageParams, this.searchParams);
        // this.handlerInitPicture(rows) // 没有图片使用默认的系统图片
        this.total = total
        this.isEmpty = rows.length === 0;
        this.resultList = rows;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // handlerInitPicture(rows) {
    //   rows.forEach((item) => {
    //     if (!item.fileVo) {
    //       item.fileVo = { filePath: '/static/wuxi/video_empty_bg.png' }
    //     }
    //   })
    // },
    toMore() {
      this.$router.push({ path: '/trainKnowledgeProduce' })
    },

  },
}
</script>